import { createSlice } from '@reduxjs/toolkit';
import { getEvents } from '../actions';

const initialState = {
  events: [],
  eventsLoading: false,
};

const eventsSlice = createSlice({
  name: 'events',
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder.addCase(getEvents.pending, (state) => {
      state.eventsLoading = true;
    });

    builder.addCase(getEvents.rejected, (state, action) => {
      state.eventsLoading = false;
      state.error = action.payload.error;
    });

    builder.addCase(getEvents.fulfilled, (state, action) => {
      state.eventsLoading = false;
      state.events = action.payload.events;
      state.error = '';
    });
  },
});

export default eventsSlice;
